'use client';

import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

// Note: SENTRY_DSN is optional. If not set, error tracking will be disabled.

// Only initialize if we have a DSN
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // Enable debug in development
    debug: process.env.NODE_ENV !== 'production',
    // Adjust this value in production
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
    // Don't send PII by default
    sendDefaultPii: true,
    // Add useful integrations
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.feedbackIntegration({
        colorScheme: "system",
        isNameRequired: true,
      }),
    ],
    beforeSend(event) {
      return event;
    },
  });
}

export { Sentry }; 